import axios from 'axios';
import config from '../../config';
import { apiCode, apiConfig } from '../../services';

export const SEARCH_LOADED = 'SEARCH_LOADED';
export const SEARCH_LOADING = 'SEARCH_LOADING';
export const SEARCH_ERROR = 'SEARCH_ERROR';
export const SEARCH_COMPETENCY_LOADED = 'SEARCH_COMPETENCY_LOADED';

export const loaded = payload => {
    return {
        type: SEARCH_LOADED,
        payload,
    };
};

export const loading = payload => {
    return {
        type: SEARCH_LOADING,
        payload,
    };
};

export const competencyLoaded = payload => {
    return {
        type: SEARCH_COMPETENCY_LOADED,
        payload,
    };
};

export const error = payload => {
    return {
        type: SEARCH_ERROR,
        payload,
    };
};

export const clearSearch = () => {
    return (dispatch, getState) => {
        dispatch(loaded([]));
    };
};

let searchCall = null;
export const search = (search, competencyId, competencyName, profile, manager, types, page) => {
    if (searchCall) searchCall.cancel();
    searchCall = axios.CancelToken.source();
    return (dispatch, getState) => {
        dispatch(loading(true));
        dispatch(error(false));

        const { guid } = getState().user.user;
        return axios
            .get(
                `${config.apiGateway.URL}search${apiCode(
                    true
                )}search=${search}&competencyId=${competencyId}&competencyName=${competencyName}&profile=${profile}&manager=${manager}&types=${types}&page=${page}`,
                {
                    ...apiConfig(guid),
                    cancelToken: searchCall.token,
                }
            )
            .then(response => {
                dispatch(loaded(response.data));
                dispatch(loading(false));
                dispatch(error(false));
            })
            .catch(err => {
                dispatch(error(true));
                dispatch(loading(false));
            });
    };
};

export const loadCompetency = id => {
    return (dispatch, getState) => {
        dispatch(error(false));

        const { guid } = getState().user.user;
        return axios
            .get(`${config.apiGateway.URL}competency/${id}${apiCode()}`, apiConfig(guid))
            .then(response => {
                dispatch(competencyLoaded(response.data));
                dispatch(error(false));
            })
            .catch(err => {
                // console.log(err);
                dispatch(error(true));
            });
    };
};
